import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
    // Token added to request headers
  } else {
    console.log('⚠️ [API] No auth token found in localStorage');
  }
  return config;
});

api.interceptors.response.use(
  (response) => {
    console.log('✅ [API] Request successful:', response.config.url);
    return response;
  },
  (error) => {
    console.error('❌ [API] Request failed:', error.response?.status, error.response?.data);
    if (error.response?.status === 401) {
      console.error('🔐 [API] Authentication failed - redirecting to login');
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const register = async (email, password) => {
  const res = await api.post('/register', { email, password });
  if (res.data?.access_token) localStorage.setItem('token', res.data.access_token);
  return res;
};

export const login = async (email, password) => {
  const params = new URLSearchParams();
  params.append('username', email);
  params.append('password', password);
  const res = await api.post('/login', params, {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  });
  if (res.data?.access_token) localStorage.setItem('token', res.data.access_token);
  return res;
};

export const getProfile = () => api.get('/profile');
export const getCameras = () => api.get('/cameras');
export const addCamera = (cameraData) => api.post('/cameras', cameraData);
export const updateCamera = (cameraId, cameraData) => api.put(`/cameras/${cameraId}`, cameraData);
export const deleteCamera = (cameraId) => api.delete(`/cameras/${cameraId}`);
export const startCamera = (cameraId) => api.post(`/cameras/${cameraId}/start`);
export const stopCamera = (cameraId) => api.post(`/cameras/${cameraId}/stop`);
export const getAlerts = () => api.get('/alerts');
export const getAdminUsers = () => api.get('/admin/users');

export const deleteAlert = async (alertId) => {
  try {
    console.log(`🗑️ [API] Deleting alert ${alertId}`);
    const response = await api.delete(`/alerts/${alertId}`);
    console.log('✅ [API] Alert deleted successfully');
    return response.data;
  } catch (error) {
    console.error('❌ [API] Failed to delete alert:', error);
    throw error;
  }
};

export const getCurrentUser = async () => {
  const token = localStorage.getItem('token');
  if (!token) return null;
  try {
    const { data } = await getProfile();
    return data;
  } catch {
    return null;
  }
};

export const logoutUser = () => {
  localStorage.removeItem('token');
};

// Firebase authentication
export const firebaseAuth = async (firebaseToken) => {
  try {
    console.log('🔐 [API] Authenticating with Firebase token');
    const response = await api.post('/firebase-auth', { 
      firebase_token: firebaseToken 
    });
    
    if (response.data?.access_token) {
      localStorage.setItem('token', response.data.access_token);
      console.log('✅ [API] Firebase authentication successful');
    }
    
    return response;
  } catch (error) {
    console.error('❌ [API] Firebase authentication failed:', error);
    throw error;
  }
};

export default api;